import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'
import { FC } from 'react'

const StyledBox = styled(Box)(({ theme }) => ({
    borderRadius: '0.5rem',
    overflow: 'hidden',
    marginTop: '4rem',
    border: '0.1rem solid #d0021b',
}))

interface ValidationMessagesProps {
    children?: React.ReactNode
}

export const ValidationMessages: FC<ValidationMessagesProps> = (props) => {
    return <StyledBox>{props.children}</StyledBox>
}
